import { render, staticRenderFns } from "./Pair.vue?vue&type=template&id=5f5923f2&"
import script from "./Pair.vue?vue&type=script&lang=js&"
export * from "./Pair.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports